import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './MapToolBarMobile.module.css';
import MapToolButton from '../UI/Buttons/MapToolButton';
import MapBackgroundLayer from '../MapBackgroundLayer/MapBackgroundLayer';
import * as actions from '../../store/actions/index';
import Statistics from '../../containers/Statistics/Statistics';

class MapToolBarMobile extends Component {

    state = {
        showPanel:false,
        panel:null
    }

    zoomIn = () => {
        this.props.mapRef.leafletElement.zoomIn();
    }

    zoomOut = () => {
        this.props.mapRef.leafletElement.zoomOut();
    }

    togglePanel = (panel) => {
        const currentPanel = this.state.panel;

        if (currentPanel === panel){
            this.setState({showPanel:!this.state.showPanel})
        } else {
            this.setState({showPanel:true, panel:panel})
        }
    }

    closePanel = () => {
        this.setState({showPanel:false})
    }
    
    render(){
        let panelContent = null;


        panelContent = <div className={this.state.showPanel ? [classes.BackgroundLayersPanel,classes.Show].join(' ') : classes.BackgroundLayersPanel}>
                            <div className={classes.BasemapsTitleRow}>
                                <span>Επίπεδα</span>
                                <svg onClick={this.closePanel} className={classes.CloseBasemaps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.96 74.83"><path d="M5.68,42.26c-3.42,0-5.71-2-5.68-4.91s2.3-4.91,5.75-4.92c8.21,0,16.41-.08,24.61,0,1.91,0,2.25-.54,2.23-2.32-.1-8.32-.06-16.65,0-25,0-3.35,2.35-5.47,5.54-5.15,2.61.26,4.32,2.33,4.32,5.32,0,8.32.08,16.65,0,25,0,1.88.56,2.15,2.23,2.13,8.2-.09,16.41,0,24.61,0,2.76,0,4.63,1.14,5.4,3.19A4.83,4.83,0,0,1,70,42.23c-8.5.05-17,.07-25.5,0-1.64,0-2.16.28-2.14,2.06.11,8.44.06,16.88,0,25.32a4.89,4.89,0,0,1-3.46,5,4.78,4.78,0,0,1-5.36-1.67,5.66,5.66,0,0,1-1.06-3.65c0-8.44,0-16.88,0-25.32,0-1.43-.41-1.73-1.76-1.71C26.52,42.32,9.76,42.27,5.68,42.26Z"></path></svg>                        
                            </div>
                            <div className={classes.MapLayersContent}>
                                {this.props.legendItems}
                            </div>
                        </div>
                        
        if (this.state.panel === "basemaps"){
            panelContent = <div className={this.state.showPanel ? [classes.BackgroundLayersPanel,classes.Show].join(' ') : classes.BackgroundLayersPanel}>
                                <div className={classes.BasemapsTitleRow}>
                                    <span>Background</span>
                                    <svg onClick={this.closePanel} className={classes.CloseBasemaps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.96 74.83"><path d="M5.68,42.26c-3.42,0-5.71-2-5.68-4.91s2.3-4.91,5.75-4.92c8.21,0,16.41-.08,24.61,0,1.91,0,2.25-.54,2.23-2.32-.1-8.32-.06-16.65,0-25,0-3.35,2.35-5.47,5.54-5.15,2.61.26,4.32,2.33,4.32,5.32,0,8.32.08,16.65,0,25,0,1.88.56,2.15,2.23,2.13,8.2-.09,16.41,0,24.61,0,2.76,0,4.63,1.14,5.4,3.19A4.83,4.83,0,0,1,70,42.23c-8.5.05-17,.07-25.5,0-1.64,0-2.16.28-2.14,2.06.11,8.44.06,16.88,0,25.32a4.89,4.89,0,0,1-3.46,5,4.78,4.78,0,0,1-5.36-1.67,5.66,5.66,0,0,1-1.06-3.65c0-8.44,0-16.88,0-25.32,0-1.43-.41-1.73-1.76-1.71C26.52,42.32,9.76,42.27,5.68,42.26Z"></path></svg>                        
                                </div>
                                <ul className={classes.BasemapsWrapper}>
                                    {this.props.basemapLayers.map((basemapLayer,index) => (
                                        <MapBackgroundLayer
                                            key={index}
                                            image={basemapLayer.image}
                                            label={basemapLayer.label} 
                                            active={this.props.selectedBasemap === index}
                                            clicked={() => this.props.onChangeBackground(index)}
                                        />
                                    ))}
                                </ul>
                            </div>
        } else if (this.state.panel === "statistics"){
            panelContent = <div className={this.state.showPanel ? [classes.BackgroundLayersPanel,classes.Show].join(' ') : classes.BackgroundLayersPanel}>
                                <div className={classes.BasemapsTitleRow}>
                                    <span>Στατιστικά</span>
                                    <svg onClick={this.closePanel} className={classes.CloseBasemaps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.96 74.83"><path d="M5.68,42.26c-3.42,0-5.71-2-5.68-4.91s2.3-4.91,5.75-4.92c8.21,0,16.41-.08,24.61,0,1.91,0,2.25-.54,2.23-2.32-.1-8.32-.06-16.65,0-25,0-3.35,2.35-5.47,5.54-5.15,2.61.26,4.32,2.33,4.32,5.32,0,8.32.08,16.65,0,25,0,1.88.56,2.15,2.23,2.13,8.2-.09,16.41,0,24.61,0,2.76,0,4.63,1.14,5.4,3.19A4.83,4.83,0,0,1,70,42.23c-8.5.05-17,.07-25.5,0-1.64,0-2.16.28-2.14,2.06.11,8.44.06,16.88,0,25.32a4.89,4.89,0,0,1-3.46,5,4.78,4.78,0,0,1-5.36-1.67,5.66,5.66,0,0,1-1.06-3.65c0-8.44,0-16.88,0-25.32,0-1.43-.41-1.73-1.76-1.71C26.52,42.32,9.76,42.27,5.68,42.26Z"></path></svg>                        
                                </div>
                                <div className={classes.MapLayersContent}>
                                    <Statistics />
                                </div>
                            </div>
        } 


        return (
            <div className={this.props.hideToolbars ? [classes.ToolBarWrapper, classes.HideToolbars].join(' ') : classes.ToolBarWrapper}>
                {panelContent}
                <div className={classes.ToolButtonsMobileWrapper}>
                    <MapToolButton
                        clicked={() => this.togglePanel("layers")}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"></path></svg>
                        <span>Επίπεδα</span>
                    </MapToolButton>

                    <MapToolButton
                        clicked={() => this.togglePanel("statistics")}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"></path></svg>
                        <span>Στατιστικά</span>
                    </MapToolButton>

                    <MapToolButton
                        clicked={() => this.togglePanel("basemaps")}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"></path></svg>
                        <span>Background</span>
                    </MapToolButton>
                    
                    <MapToolButton
                        clicked={this.zoomIn}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.96 74.83"><path d="M5.68,42.26c-3.42,0-5.71-2-5.68-4.91s2.3-4.91,5.75-4.92c8.21,0,16.41-.08,24.61,0,1.91,0,2.25-.54,2.23-2.32-.1-8.32-.06-16.65,0-25,0-3.35,2.35-5.47,5.54-5.15,2.61.26,4.32,2.33,4.32,5.32,0,8.32.08,16.65,0,25,0,1.88.56,2.15,2.23,2.13,8.2-.09,16.41,0,24.61,0,2.76,0,4.63,1.14,5.4,3.19A4.83,4.83,0,0,1,70,42.23c-8.5.05-17,.07-25.5,0-1.64,0-2.16.28-2.14,2.06.11,8.44.06,16.88,0,25.32a4.89,4.89,0,0,1-3.46,5,4.78,4.78,0,0,1-5.36-1.67,5.66,5.66,0,0,1-1.06-3.65c0-8.44,0-16.88,0-25.32,0-1.43-.41-1.73-1.76-1.71C26.52,42.32,9.76,42.27,5.68,42.26Z"/></svg>
                        <span>Zoom in</span>
                    </MapToolButton>

                    <MapToolButton
                        clicked={this.zoomOut}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.88 9.82"><path d="M5.77,9.81C2.56,9.81.84,8.62.16,6A4.8,4.8,0,0,1,4,.13,12.61,12.61,0,0,1,5.92,0h63c3.28,0,5,1.11,5.74,3.6a4.76,4.76,0,0,1-4,6.1,18.34,18.34,0,0,1-2.29.11C58.1,9.82,16.33,9.82,5.77,9.81Z"/></svg>
                        <span>Zoom out</span>
                    </MapToolButton>

                    <MapToolButton
                        clicked={this.props.zoomExtent}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path d="M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"></path></svg>
                        <span>Full extent</span>
                    </MapToolButton>
                </div>
                
            </div>
        )
    }
};

const mapStateToProps = state => {
    return {
        basemapLayers:state.webgis.basemapLayers,
        selectedBasemap:state.webgis.selectedBasemap
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeBackground: (index) => dispatch(actions.changeBackground(index)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapToolBarMobile);